var backToShop = document.querySelector('.return-to-shop a.wc-backward');


if (backToShop) {
   backToShop.setAttribute('href', '/');
}
